if (!customElements.get('aura5-hero-video')) {
  customElements.define('aura5-hero-video', class extends HTMLElement {
    connectedCallback() {
      this.viewport = matchMedia('(max-width: 749px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.renderVideo = () => {
        this.querySelector(':scope > video')?.pause();
        this.querySelector(':scope > video')?.remove();
        const template = this.querySelector(this.viewport.matches ? '[data-mobile-video]' : '[data-desktop-video]');
        if (!template) return;
        this.append(template.content.cloneNode(true));
        const video = this.querySelector(':scope > video');
        if (video && this.dataset.autoplay === 'true' && !this.motion.matches) video.play().catch(() => {});
      };
      this.onMotion = () => { if (this.motion.matches) this.querySelector(':scope > video')?.pause(); };
      this.viewport.addEventListener('change', this.renderVideo);
      this.motion.addEventListener('change', this.onMotion);
      this.renderVideo();
    }
    disconnectedCallback() {
      this.viewport?.removeEventListener('change', this.renderVideo);
      this.motion?.removeEventListener('change', this.onMotion);
      this.querySelector(':scope > video')?.pause();
    }
  });
}
